import { spellerFor } from '../i18n/numbers'
import type { Language } from '../types/document'
import { normalizeDigits } from './extract/text'

/**
 * Rewrites text so a voice that cannot read digits can speak it:
 * "₹84,000" → "चौरासी हज़ार रुपये", "7 अक्तूबर 2026" → "सात अक्तूबर दो हज़ार छब्बीस",
 * long ID/phone numbers are read digit by digit.
 */
export function verbalize(text: string, language: Language): string {
  const sp = spellerFor(language)
  const digits = (s: string) => [...s].map((d) => sp.spell(Number(d))).join(' ')

  let out = normalizeDigits(text)
    // "1,236.00" → "1236"; keep the whole-rupee part for speech
    .replace(/(\d)[,٬](?=\d{2,3}\b)/g, '$1')
    .replace(/(\d+)\.\d{1,2}(?!\d)/g, '$1')

  // ₹ / Rs. amounts → "<number> rupees"
  out = out.replace(/(?:₹|\bRs\.?\s*|\bINR\s*)\s*(\d+)/gi, (_m, n) => `${sp.spell(Number(n))} ${sp.rupees}`)
  // Years (1900–2099) read the way people say them
  out = out.replace(/(?<!\d)(19|20)(\d{2})(?!\d)/g, (_m, a, b) => sp.year(Number(a + b)))
  // Phone numbers, IDs and other long digit runs: digit by digit
  out = out.replace(/\d{5,}/g, (m) => digits(m))
  // Everything else
  out = out.replace(/\d+/g, (m) => sp.spell(Number(m)))

  return out.replace(/[/:|_]+/g, ' ').replace(/\s+/g, ' ').trim()
}
